import * as React from 'react';

import { HelpYouBuyContainer } from 'shared/landingBuyer/containers/HelpYouBuyContainer';
import { Faq } from 'shared/landingBuyer/components/Faq';
import { FormBannerContainer } from 'shared/landingBuyer/containers/FormBannerContainer';
import { HowItWorksContainer } from 'shared/landingBuyer/containers/HowItWorksContainer';
import { useSetSeenLandingInCookie } from 'shared/common/hooks/useSetSeenLandingInCookie';
import { useFillApplicationStickyButtons } from 'shared/common/containers/StickyPromo/useFillApplicationStickyButtons';
import { StickyPromo } from 'shared/common/containers/StickyPromo/StickyPromo';
import { SelectBestAgentContainer } from '../SelectBestAgentContainer';
import { WhyNeedRealtorContainer } from '../WhyNeedRealtorContainer';
import { ModalFormContainer } from '../../../common/containers/ModalFormContainer';
import { EPageName } from '../../../common/constants/pages';
import { GarantLabel } from '../../components/GarantLabel';
import { BuyWithCianContainer } from '../BuyWithCianContainer';

export const BuyerPageContainer: React.FC = () => {
  useSetSeenLandingInCookie();
  useFillApplicationStickyButtons({ landing: 'buyer' });

  return (
    <>
      <GarantLabel />
      <HelpYouBuyContainer />
      <BuyWithCianContainer />
      <HowItWorksContainer />
      <SelectBestAgentContainer />
      <WhyNeedRealtorContainer />
      <FormBannerContainer />
      <Faq />
      <ModalFormContainer modalPageType={EPageName.LandingBuyer} />
      <StickyPromo landing="buyer" />
    </>
  );
};
